import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { ReactElement } from 'react';
import { SIDEBAR_RULE } from './tabs-sidebar.styles';

/** A tooltip naming a sidebar control, to its right unless told otherwise. */
export function SidebarTooltip({
  label,
  side = 'right',
  children,
}: {
  label: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: ReactElement;
}) {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} sideOffset={8}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}

/** The short rule between the folded sidebar's groups. */
export function SidebarRule({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('my-1 h-px w-7 shrink-0', SIDEBAR_RULE, className)}
    />
  );
}
